export const MAGNOLIA_FETCH_ERROR = 'MagnoliaFetchError';
